import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Radio, Row, Space } from 'antd';
import { useHistory } from 'react-router';
import {
  useAuth,
  useBraveUpSurveysApi,
  useGetSurveyRoles,
  useSendMetricsQuestionPro,
  useSendSurveyRoles,
} from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import styles from './start-survey.module.css';

const questioProUrl = process.env.REACT_APP_QUESTION_PRO_URL;
const questionProApiKey = process.env.REACT_APP_QUESTION_PRO_API_KEY;
const questionProUserId = process.env.REACT_APP_QUESTION_PRO_USER_ID;

const StartSurvey = ({ userName, surveyUrl }) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const { user } = useAuth();
  const { survey } = useBraveUpSurveysApi();
  const rolName = user?.roles?.name;
  const roleId = user?.roles?.id;
  const organizationId = user?.organizations?.id;
  const enrollmentId = user?.enrollmentId;
  const surveyId = survey?.id;
  const folderID = survey?.folder_id_questionpro;
  const baseUrl = questioProUrl;
  const apiKey = questionProApiKey;
  const userId = questionProUserId;
  const { isConsumeFromBraveup, isConsumeFromQP } = useGetSurveyRoles(
    surveyId,
    folderID,
    roleId,
    rolName
  );
  const requestUrl = `${baseUrl}/users/${userId}/folders/${folderID}/surveys?apiKey=${apiKey}`;
  const { surveyRoles, surveyQP } = useGetSurveyRoles(
    surveyId,
    folderID,
    roleId,
    rolName
  );
  const { sendMetricsQP } = useSendMetricsQuestionPro();
  const { sendDataSurveysRoles } = useSendSurveyRoles();

  const questionproSurveyUrl = surveyQP?.url;

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    const { selectedOption } = values;
    if (selectedOption) {
      await sendMetricsQP({
        data: {
          requestUrl,
          isConsumeFromQP,
          isConsumeFromBraveup,
          organizationId,
          roleId,
          enrollmentId,
          // timeInSeconds: 1,
        },
      });

      if (surveyQP !== {} && !surveyRoles) {
        await sendDataSurveysRoles({
          data: {
            questionproSurveyUrl,
            surveyId,
            roleId,
            isActive: true,
          },
        });
      }
      window.open(surveyUrl, '_blank');
      history.push('/data');
    } else {
      history.push('/data/confirm-survey/desert-survey');
    }
  };

  const capitalizeName = (name) => name.charAt(0).toUpperCase() + name.slice(1);
  const [t] = useTranslation();
  return (
    <>
      <h1 className={styles.title}>{t('pages.data.startSurvey.title')}</h1>
      <Row>
        <Col className={styles.description_wrapper}>
          <h2>
            {userName
              ? `¡Hola ${capitalizeName(userName.split(' ')[0])}!`
              : '¡Hola!'}
          </h2>
          <p>{t('pages.data.startSurvey.messageStart')}</p>
        </Col>
      </Row>
      <Row align="center">
        <Col xs={24} lg={16}>
          <div className={styles.video_wrapper}>
            <iframe
              title="data-page__survey-confirm-iframe"
              src="https://www.youtube.com/embed/_zwnr2hd7sQ"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Col>
      </Row>
      <Row className={styles.form_wrapper}>
        <Col xs={24}>
          <h2 className={styles.form_title}>
            {t('pages.data.startSurvey.askMessage')}
          </h2>
        </Col>
        <Col xs={24}>
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Form.Item
              name="selectedOption"
              rules={[
                {
                  required: true,
                  message: t('pages.data.startSurvey.messageRequired'),
                },
              ]}
            >
              <Radio.Group>
                <Space direction="vertical">
                  <Radio value>{t('pages.data.startSurvey.yesMessage')}</Radio>
                  <Radio value={false}>
                    {t('pages.data.startSurvey.noMessage')}
                  </Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  className={styles.form_button}
                  htmlType="submit"
                  disabled={
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                  // onClick={handleClickSendMetrics}
                >
                  {t('pages.data.startSurvey.nextMessage')}
                </Button>
              )}
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default StartSurvey;
